export default {
  existing_documents: {
    description:
      'Ați încărcat deja următoarele documente. Selectați unul și apăsați trimite, sau încărcați un document nou.',
    sides: {
      front: 'Față',
      back: 'Verso',
    },
    created_at: 'Încărcat: {{date}}',
    expires_at: 'Expiră: {{date}}',
  },
  document_types: {
    owner_document: 'Document de identitate al proprietarului',
    business_document: 'Document de afacere',
  },
  form: {
    document_type: {
      label: 'Document doveditor de identitate',
      placeholder: 'Selectați tipul documentului',
      options: {
        passport: 'Pașaport',
        driver_license: 'Permis de conducere',
        id_card: 'Carte de identitate',
        residence_permit: 'Permis de reședință',
      },
    },
    front: {
      label: 'Față document',
    },
    back: {
      label: 'Verso document (opțional pentru unele documente)',
    },
    expires_at: {
      label: 'Data expirării documentului',
      placeholder: 'Selectați data expirării',
    },
  },
  buttons: {
    select_file: 'Selectați fișierul',
    next: 'Următor',
    back: 'Verso',
    send: 'Trimiteți',
    upload_new: 'Încărcați un document nou',
    use_existing: 'Utilizați un document încărcat',
  },
};
